'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import a$1 from "../defs/User.es.js";
const o = a.forwardRef((r, s) => /* @__PURE__ */ a.createElement(p, { ref: s, ...r, weights: a$1 }));
o.displayName = "UserIcon";
const n = o;
export {
  n as User,
  o as UserIcon
};
